import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  convert(e) {
    const value = e.target.value;
    const trimmedValue = value.trim();
    const hankakuValue = trimmedValue.replace(/[０-９－ー]/g, (match) => {
      return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
    });
    const cleanedString = hankakuValue.replace(/[-‐−–—﹣‑－‒]/g, '');

    e.target.value = cleanedString;
  }
}
